import { Shark, Utils, View } from "shark-mvc";
import { Collapse } from "bootstrap";

import Activity from "../../models/Activity";
import Note from "../../models/Note";
import Task from "../../models/Task";

import templateContent from "./task-list.html";
import "./style.css";

import activityManager from "../../controllers/activityManager";
import attachmentsViewerComponent from "../../components/attachments-viewer/attachmentsViewerComponent";
import mainNavComponent from "../../components/main-nav/mainNavComponent";
import noteManager from "../../controllers/noteManager";
import noteModalComponent from "../../components/note-modal/noteModalComponent";
import priorityFilterComponent from "../../components/priorityFilter/priorityFilterComponent";
import taskManager from "../../controllers/taskManager";
import taskModalComponent from "../../components/taskModal/taskModalComponent";
import userManager from "../../controllers/userManager";
import userPermissionManager from "../../controllers/userPermissionManager";
import waitBoxComponent from "../../components/wait-box/waitBoxComponent";

class TaskListView extends View {
	constructor () {
		super("taskListView");

		this.setTemplate(templateContent);
		this.$mainRoute = "tasks";
	}

	afterLoad () {
		this.taskDetailBoxNode = document.querySelector("#taskDetailBox");

		if (this.taskDetailBoxNode) {
			this.taskDetailBoxCollpase = new Collapse(this.taskDetailBoxNode, { toggle: false });
		}
	}

	async archiveTask (guid) {
		const { taskList } = Shark.get();
		const selectedTask = Utils.safp(taskList, "guid", guid);

		if (selectedTask && confirm(`Vuoi davvero archiviare "${selectedTask.name}"`)) {
			selectedTask.set({
				status: Task.STATUS_ARCHIVED,
			});

			// Dave: dovrei avere un metodo apposta
			const archiveResponse = await taskManager.save(selectedTask);
			console.log({ archiveResponse });
			
			if (archiveResponse.status === "ok") {
				Shark.set({
					taskList,
				});
			}
		}
	}

	archiveTaskBtn_clickHandler (event, data) {
		this.archiveTask(data.guid);
	}

	async beforeLoad () {
		Shark.set({
			__pageTitle: "Task",
		});

		await userManager.checkUserList();
		const urlParams = new URLSearchParams(document.location.search);
		
		if (!Shark.$store.currActivity) {
			if (urlParams.has("actguid")) {
				activityManager.getByGuid(urlParams.get("actguid"))
				.then(getByGuidResponse => {
					const currActivity = new Activity(getByGuidResponse.data[0]);

					Shark.set({
						currActivity,
					});

					this.refreshList(urlParams.get("actguid"));
				});
			}
		}
		else {
			this.refreshList(Shark.$store.currActivity.guid);
		}
	}

	beforeUnload () {
		Shark.set({
			taskList: [],
		});
	}

	filterTaskList () {
		const { fullTaskList, loggedUser, taskViewFilters } = Shark.get();
		const key = taskViewFilters.searchKey.toLowerCase();
		const filteredTskList = fullTaskList.filter(item => {
			return (key !== "" && (item.name.toLowerCase().includes(key) || item.body.toLowerCase().includes(key))) || (!taskViewFilters.showMineTask || (taskViewFilters.showMineTask && item.assigneeGuid === loggedUser.guid));
		});

		Shark.set({
			taskList: filteredTskList,
		});
	}

	async getNotesBtn_clickHandler (event, data) {
		console.log({data});
		console.log({ariaExpanded: event.target.ariaExpanded});
		if (!event.target.ariaExpanded || event.target.ariaExpanded === "true") {
			const { taskGuid } = data;
			
			const selectedTask = Utils.safp(Shark.$store.taskList, "guid", taskGuid);
			const noteListResponse = await noteManager.getListByTaskGuid(taskGuid);
			const noteList = Shark.getInstanceList(Note, noteListResponse.data);
			// const { currTask } = Shark.get();
			
			if (selectedTask) {
				selectedTask.set({
					__hasNotes: noteList.length > 0,
					__noteList: noteList,
				});
				Shark.render();
			}
		}
	}

	init () {
		this.addComponents([attachmentsViewerComponent, noteModalComponent, mainNavComponent, priorityFilterComponent, taskModalComponent, waitBoxComponent]);
		
		const taskViewFiltersData = Utils.parseJSON(localStorage.getItem("taskViewFilters"), "object");
		
		const taskViewFilters = Shark.getInstance("__smart__", {
			searchKey: "",
			showArchivedTask: taskViewFiltersData ? taskViewFiltersData.showArchivedTask : false,
			showCanceledTask: taskViewFiltersData ? taskViewFiltersData.showCanceledTask : false,
			showClosedTask: taskViewFiltersData ? taskViewFiltersData.showClosedTask : false,
			showMineTask: taskViewFiltersData ? taskViewFiltersData.showMineTask : true,
			showOpenTask: taskViewFiltersData ? taskViewFiltersData.showOpenTask : true,
			showPriority1: taskViewFiltersData ? taskViewFiltersData.showPriority1 : true,
			showPriority2: taskViewFiltersData ? taskViewFiltersData.showPriority2 : true,
			showPriority3: taskViewFiltersData ? taskViewFiltersData.showPriority3 : true,
			showPriority4: taskViewFiltersData ? taskViewFiltersData.showPriority4 : true,
			showPriority5: taskViewFiltersData ? taskViewFiltersData.showPriority5 : true,
		});

		taskViewFilters.onDataChanged = function (data) {
			localStorage.setItem("taskViewFilters", JSON.stringify(this.export()));

			if (!["searchKey", "showMineTask"].includes(data.property)) {
				taskListView.refreshList(Shark.$store.currActivity.guid);
			}
			else {
				taskListView.filterTaskList();
				// const key = this.searchKey.toLowerCase();
				// const { fullTaskList, loggedUser } = Shark.get();
				// const filteredTskList = fullTaskList.filter(item => {
				// 	return (key !== "" && (item.name.toLowerCase().includes(key) || item.body.toLowerCase().includes(key))) || (!this.showMineTask || (this.showMineTask && item.assigneeGuid === loggedUser.guid));
				// });
				// Shark.set({
				// 	taskList: filteredTskList,
				// });
			}
		};
		// console.log({taskViewFilters, taskViewFiltersData});

		Shark.set({
			loggedUserCanAddTasks: false,
			loggedUserCanAssignTasks: false,
			loggedUserCanCancelTask: false,
			loggedUserCanCloseTasks: false,
			loggedUserCanEditTasks: false,
			filteredTskList: [],
			fullTaskList: [],
			taskList: [],
			taskViewFilters,
		});
	}

	linkedToBox_clickHandler (event, data) {
		const refCode = data.refcode.slice(1);
		const targetTaskNode = document.querySelector(`li[data-guid^="${refCode}"]`);

		if (targetTaskNode) {
			targetTaskNode.parentNode.scrollTop = targetTaskNode.offsetTop - 30;
			targetTaskNode.classList.add("hilite");

			setTimeout(function(){
				targetTaskNode.classList.remove("hilite");
			}, 3000);
		}
	}

	// Dave: Sono fesso, ora che è nel modal non posso più fare questa cosa.. :|
	// refCodeBtn_clickHandler (event) {
	// 	// event.preventDefault();
	// 	// event.stopPropagation();
	// 	const { currTask } = Shark.get();
	// 	console.log(this.lastRefCodeTarget);

	// 	const referenceCode = ` <span class="linkedToBox" data-refcode="${event.target.innerText}">${event.target.innerText}</span> `;
	// 	let newValue = referenceCode;

	// 	if (this.lastRefCodeTarget) {
	// 		const myField = this.lastRefCodeTarget;
			
	// 		if (document.selection) {
	// 			myField.focus();
	// 			const selection = document.selection.createRange();
	// 			selection.text = referenceCode;
	// 		}
	// 		else if (myField.selectionStart || myField.selectionStart == "0") {
	// 			const startPos = myField.selectionStart;
	// 			const endPos = myField.selectionEnd;

	// 			newValue = myField.value.substring(0, startPos)
	// 			+ referenceCode
	// 			+ myField.value.substring(endPos, myField.value.length);
	// 		}
	// 		else {
	// 			newValue = currTask[this.lastRefCodeTarget.dataset.shProp] + referenceCode;
	// 		}

	// 		if (this.lastRefCodeTarget.dataset.shProp === "body") {
	// 			// this.tinyEditor.execCommand("mceInsertContent", false, newValue);
	// 			// tinymce.activeEditor.execCommand("mceInsertContent", false, newValue);
	// 		}
	// 		else {
	// 			currTask.set({
	// 				[this.lastRefCodeTarget.dataset.shProp]: newValue,
	// 			});
	// 		}

	// 		myField.focus();
	// 	}
	// 	else {
	// 		this.tinyEditor.execCommand("mceInsertContent", false, newValue);
	// 		// tinymce.activeEditor.execCommand("mceInsertContent", false, newValue);
	// 	}
	// }

	// refCodeTarget_blurHandler () {
	// 	this.lastRefCodeTarget = null;
	// }

	// refCodeTarget_focusHandler (event) {
	// 	this.lastRefCodeTarget = event.target;
	// }

	async loadUserPermissions (activityGuid) {
		const { currActivity } = Shark.get();
		const userPermissionResponse = await userPermissionManager.getActiveForUserByActivityGuid(activityGuid);
		console.log({userPermissionResponse});

		if (userPermissionResponse.data.length > 0) {
			const currProjectUserPermissions = userPermissionResponse.data[0];

			Shark.set({
				currProjectUserPermissions,
				loggedUserCanAddTasks: currProjectUserPermissions.hasPermission("addTask"),
				loggedUserCanAssignTasks: currProjectUserPermissions.hasPermission("assignTask"),
				loggedUserCanCancelTask: currProjectUserPermissions.hasPermission("cancelTask"),
				loggedUserCanCloseTasks: currProjectUserPermissions.hasPermission("closeTask"),
				loggedUserCanEditTasks: currProjectUserPermissions.hasPermission("editTask"),
			});
		}
		else{
			Shark.set({
				loggedUserCanAddTasks: currActivity.__userIsOwner,
				loggedUserCanAssignTasks: currActivity.__userIsOwner,
				loggedUserCanCancelTask: currActivity.__userIsOwner,
				loggedUserCanCloseTasks: currActivity.__userIsOwner,
				loggedUserCanEditTasks: currActivity.__userIsOwner,
			});
		}
	}

	async refreshList (activityGuid, reloadPermissions = true) {
		waitBoxComponent.open();

		if (reloadPermissions) {
			await this.loadUserPermissions(activityGuid);
		}

		await taskManager.getListByActivityGuid(activityGuid, Shark.$store.taskViewFilters)
		.then(response => {
			console.log({response});

			const taskList = Shark.getInstanceList(Task, response.data);

			taskList.forEach((item, index) => {
				item.__index = index;
				item.__displayIndex = index + 1;
				// item.rnd = Math.random();//Alla ricreazione delle list quando riassegno gli __shguid dovrei poi usarli per calcolare l'hash, se no non si accorge del reload... ma è tutto vero davvero?
			});

			Shark.set({
				filteredTskList: [...taskList],
				fullTaskList: [...taskList],
				taskList,
			});

			this.filterTaskList();

			waitBoxComponent.close();
		});
	}

	refresListBtn_clickHandler () {
		if (Shark.$store.currActivity) {
			this.refreshList(Shark.$store.currActivity.guid);
		}
	}

	// projectListView.addMethod("prjName_keydownHandler", function (event) {
	// 	if (event.which === 13) {
	// 		event.preventDefault();
	// 		projectManager.create(Shark.get("newProject"));
	// 	}
	// });
}

const taskListView = new TaskListView();

Shark.registerView(taskListView);

export default taskListView;
